export const DATA_TABLE_NS = 'cardsTable';
